import { Col, FormGroup, Input, Label } from "reactstrap";
import styles from "./index.module.scss";

const InputField = ({ label, value, id, type, onChange, isFullWidth }) => {
    const handleFormChange = (e) => onChange(e.target.value);

    // Ensure value is never null - convert to empty string if needed
    const safeValue = value || "";

    return (
        <Col className={`${styles.inputField} col-12 ${!isFullWidth ? 'col-md-6' : ''} px-2`}>
            <FormGroup className="">
                <h5 className="mt-4">
                    <Label htmlFor={id} className={styles.label}>{label}</Label>
                </h5>
                <Input value={safeValue}
                    onChange={handleFormChange}
                    type={type}
                    id={id}
                    className={styles.input} />

            </FormGroup>
        </Col>
    )
}

export default InputField;